import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconApplicationStatusDraft.tsx
const IconApplicationStatusDraft = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "m2.5 6.667 5.003-5h9.162c.461 0 .835.379.835.826v15.014c0 .456-.37.826-.828.826H3.328a.833.833 0 0 1-.828-.839zm3.748 7.5H9.44l4.067-4.067a.834.834 0 0 0 0-1.179l-2.013-1.965a.833.833 0 0 0-1.178 0l-4.067 4.067z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "m11.738 9.51-2.99 2.99h-.833v-.786l2.99-2.99z",
			clipRule: "evenodd"
		})
	]
});
var IconApplicationStatusDraft_default = forwardRef(IconApplicationStatusDraft);
//#endregion
export { IconApplicationStatusDraft_default as default };
